import {ProductionMachine, ProductionMachineListQueryForm} from './production-machine.model';
import {useSuspenseQuery} from '@tanstack/react-query';
import {queryKey} from './production-machine-query-keys';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {EnvisiaObjects, Lister} from '../../../common/wrapper.models';

export function useProductionMachineList(
  query: ProductionMachineListQueryForm,
): EnvisiaObjects<ProductionMachine> {
  const {data} = useSuspenseQuery({
    queryKey: queryKey.list(query),
    queryFn: () => AxiosHttpClient.get<Lister<ProductionMachine>>(
      `${environment.apiv4uri}production/machines`,
      query,
    ),
  });

  return data;
}
